// extracted by mini-css-extract-plugin
export default {"container":"KYCLevel2_container__Phh5x","main-1":"KYCLevel2_main-1__6Q4FW"};